import {
  axiosLeadInfoUtility,
  axiosPincodeInfoUtility,
  axiosAppFormUtility,
  axiosAppAffilcate
} from "../http/axiosUtility";
import _, { add, reject } from "lodash";
import moment from "moment";
import constant from "./constant";
import axios from 'axios';
import aesEcb from "aes-ecb";
import { Buffer } from 'buffer';
window.Buffer = Buffer;


export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};


class HTTPRequest {
  static GET = (type, url) => {
    return new Promise(async (resolve, reject) => {
      try {
        let utility = null;
        if (type == "pincode") {
          utility = axiosPincodeInfoUtility;
        } 
        if (utility == null) {
          return;
        }
        const response = await utility.get(url);
        
        if (typeof response == "string") {
          response = JSON.parse(response);
          // dispatch(updateQQPlanState(response)) //todo: once APIs are up
        }
        if (response.data != null && response.status == constant.API_RESPONSE_CODE_200) {
          resolve(response.data);
        } else {
          reject(response);
        }
      } catch (error) {
        console.log(
          "HTTPRequest error: " + url + " : " + JSON.stringify(error)
        );
        reject(error);
      }
    });
  };

  static POST = (type, body, url, headerData='',header = {}) => {
    if (typeof body == "object") {
      body = JSON.stringify(body);
    }
    const csrfToken = document.cookie.replace(
      /(?:(?:^|.*;\s*)XSRF-TOKEN\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    );
    header["Authorization"] =
      "Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=";
    header["X-XSRF-TOKEN"] = csrfToken;
    if(headerData){
      header["data"] = headerData;
    }
    return new Promise(async (resolve, reject) => {
      try {
        let utility = null;
        if (type == "lead_info" || type == "lead_init") {
          utility = axiosLeadInfoUtility;
        }

        if (type == "get-data") {
          utility = axiosAppFormUtility;
        }
        
        if (type == "get-affilcate-data") {
          utility = axiosAppAffilcate;
        }   
            
        if (utility == null) {
          return;
        }
        
        const response = await utility.post(url, body, header);
        //debugger;
        if (typeof response == "string") {
          response = JSON.parse(response);
        }
        if (
          response.data != null &&
          (response.status == constant.API_RESPONSE_CODE_200 || response.data.responseCode == constant.API_RESPONSE_CODE_200)
        ) {
          resolve(response.data);
        } else {
          reject(response);
        }
      } catch (error) {
        console.log(
          "HTTPRequest error: " + url + " : " + JSON.stringify(error)
        );
        reject(error);
      }
    });
  };
}

class otp {
  static sendOtp = (mobile = "", email = "") => {
    // TODO: Call Liferay service for sending Otp to this number. Liferay would manage all logic of managing & sending Otp in the back end.
    // Response should be boolean flag denoting status of sending Otp.
    var journey = "Quick Quote";
    var emailId = email;
    
    return axiosQQUtility.post("/invoke", {
      "/mchi_utilities.otp/send-otp-and-email": {
        mobile: mobile,
        email: emailId,
        journey: journey,
      },
    });
  };

  static verifyOtp = (mobile = "", otp = "") => {
    // TODO: Call Liferay service for verifying Otp for this number. Liferay would manage all logic of managing Otp in the back end.
    // Response should be boolean flag denoting status of Otp verification.
    
    return axiosQQUtility.post("/invoke", {
      "/mchi_utilities.otp/verify-otp": {
        mobile: mobile,
        code: otp,
      },
    });
  };
}

const submitData = (portletNamespace, submitURL, data) => {
  //alert("Make API call here")
  return;
  let form = document.createElement("form");

  form.method = "POST";
  form.action =
    submitURL +
    "&uuid=" +
    data.uuid +
    "&campaign=" +
    data.campaign +
    "&medium=" +
    data.medium +
    "&source=" +
    data.leadSource;

  let element = null;

  for (let key in data) {
    element = document.createElement("input");
    element.value = data[key];
    element.name = portletNamespace + key;
    form.appendChild(element);
  }
  console.log("form>>>>>> " + form);
  document.body.appendChild(form).style.display = "none";
  $(".main_loader").removeClass("hide");
  form.submit();
};

const moveBox = (current = "", now = "") => {
  var cr = document.querySelector(`#${current}`);
  var nw = document.querySelector(`#${now}`);
  if (cr) {
    cr.style.display = "none";
  }
  if (nw) {
    nw.style.display = "inline-block";
  }
};

const validateBox = (element) => {
  // This validation works basis on HTML5 form validation model. Hence all validation rules should be added in the input HTML element only.
  // TODO: Error messages to be furnished in the front end.
  let v = element.checkValidity();
  if (!v) {
    // TODO: use setCustomValidity or similar ways to display error messages.
  }
  return v;
};

const applyOwlCarousel = (element) => {
  $(element).owlCarousel({
    autoHeight: true,
    items: 6,
    nav: true,
  });
};

const applyResultOwlCarousel = (element) => {
  if ($(window).width() > 500) {
    $(element).owlCarousel({
      autoHeight: true,
      dots: true,
      margin: 10,
      responsive: {
        0: {
          items: 1,
          dots: false,
        },
        768: {
          items: 1,
        },
        991: {
          items: 2,
        },
        1200: {
          items: 3,
        },
      },
    });
  }
};

const applyDatepicker = (element) => {
  $(element).datepicker({
    format: "dd/mm/yyyy",
    autoclose: true,
    closeOnDateSelect: true,
  });
};

const applySelect2 = (element) => {
  $(element).select2();
};

const applyTooltip = (element) => {
  $(element).mouseover(function () {
    var tooltip_offset = $(this).offset();
    var offset_top = tooltip_offset.top;
    var offset_left = tooltip_offset.left;
    var height = $(".tooltiptext").height();
    var width = $(".tooltiptext").width();
    // var html = $(this).find(".tooltiptext").html();
    // $(".new_tooltip").append(html);
    $(".new_tooltip").show();
    $(".new_tooltip").css({
      top: offset_top + 30,
      left: offset_left - width - 33,
    });
  });
  $(element).mouseout(function () {
    $(".new_tooltip").mouseout(function () {
      $(".new_tooltip").hide();
      $(".new_tooltip").empty();
    });
  });
};

const isNumberKey = (evt) => {
  /*
  New Logic Implementation
  */
  // console.log(/^[0-9]{1}$/.test(evt.key), evt.key);
  if (/^[0-9]{1}$/.test(evt.key) || evt.key === "Backspace") {
    return true;
  } else {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
};

const isAlphabetKey = (evt) => {
 /*
  New Logic Implementation
  */
 
  if (/^[a-zA-Z ]*$/.test(evt.key) || evt.key === "Backspace") {
    return true;
  } else {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
};

const isAlphabetKeyWithSpace = (evt) => {
  /*
  New Logic Implementation
  */
  var k = evt ? evt.which : window.event.keyCode;
  if (/^[a-zA-Z ]*$/.test(evt.key) || evt.key === "Backspace") {
    return true;
  } else {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
};
const isAlphabetNumericKey = (evt) => {
  var k = evt ? evt.which : window.event.keyCode;
  if (k == 32) {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
  if (/^[a-zA-Z0-9 ]*$/.test(evt.key) || evt.key === "Backspace") {
    return true;
  } else {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
};

const isAlphabetKeyLastName = (evt) => {
  var k = evt ? evt.which : window.event.keyCode;
  if (/^[a-zA-Z .]*$/.test(evt.key) || evt.key === "Backspace") {
    return true;
  } else {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
};

const isValidKeyForAddress = (evt) => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  var key = evt.key;
  if (
    charCode > 32 &&
    (charCode < 65 || charCode > 90) &&
    (charCode < 97 || charCode > 122) &&
    (charCode < 48 || charCode > 57 || evt.shiftKey) &&
    (charCode < 96 || charCode > 105) &&
    key !== "#" &&
    key !== ":" &&
    key !== "." &&
    key !== "," &&
    key !== "-" &&
    key !== "\\" &&
    key !== "/" &&
    key !== "(" &&
    key !== ")" &&
    key !== "[" &&
    key !== "]" &&
    key !== ";"
  ) {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
  return true;
};

const isValidMobileNumber = (e) => {
  if (e.target.value.length === 14) {
    let mobileNo = "" + e.target.value;
    let txt = e.target.value.substring(3, mobileNo.length);
    if (txt != null) {
      e.target.value = txt?.trim();
    }
  }
  var regex = new RegExp("^[0-9]{1,10}$");
  var regexValidNumber = new RegExp("^[6-9]{1}[0-9]{9}$"); // To check if 10 digits entered
  var key = e.target.value;
  let areAllDigitsSame = key.match(/(\d)\1{9}/g) ? true : false; //To check if all digits are same
  var firstDigit = e.target.value.charAt(0);

  if (
    firstDigit === "0" ||
    firstDigit === "1" ||
    firstDigit === "2" ||
    firstDigit === "3" ||
    firstDigit === "4" ||
    firstDigit === "5"
  ) {
    e.target.value = e.target.value.substring(1);
    // alert("onNumberChanged(qid, e) : Mobile number firstDigit validation");
    // console.log("onNumberChanged(qid, e) : Mobile number firstDigit validation");
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  if (key && !regex.test(key)) {
    
    //Modifications : to turn mobile box green after 10 digits
    if (
      e.target.value.length >= 10 &&
      areAllDigitsSame === false &&
      regex.test(key)
    ) {
      //this.setState({ validNumber: true, value: e.target.value });
      return true;
    } else {
      e.target.value = key.replace(/\D/g, "").substr(0, 10);
      e.preventDefault();
      return false;
    }
  } else if (key && regexValidNumber.test(key)) {
    //Modifications : to turn mobile box green after 10 digits
    if (areAllDigitsSame === false && regex.test(key)) {
      //this.setState({ validNumber: true, value: e.target.value });
      return true;
      //this.verifyOtp(qid,e);
    } else {
      return false;
    }
  } else if (key && !regexValidNumber.test(key)) {
    console.log(
      "onNumberChanged : else if (key && !regexValidNumber.test(key))"
    );
    //setIsMobileValid(false);
  }
};

const isValidCkycNumber = (e) => {
  var regex = new RegExp("^[0-9]{1,14}$");
  //var regex = new RegExp("/^[0-9]+$/");
  var regexValidNumber = new RegExp("^[0-9]{14}$"); // To check if 14 digits entered
  var key = e.target.value;

  if (key && !regex.test(key)) {
    //Modifications : to turn mobile box green after 10 digits
    if (
      e.target.value.length >= 14 &&
      //areAllDigitsSame === false &&
      regex.test(key)
    ) {
      //this.setState({ validNumber: true, value: e.target.value });
      return true;
    } else {
      e.target.value = key.replace(/\D/g, "").substr(0, 14);
      e.preventDefault();
      return false;
    }
  } else if (key && regexValidNumber.test(key)) {
    //Modifications : to turn mobile box green after 10 digits
    if (regex.test(key)) {
      //this.setState({ validNumber: true, value: e.target.value });
      return true;
      //this.verifyOtp(qid,e);
    } else {
      return false;
    }
  } else if (key && !regexValidNumber.test(key)) {
    return false;
  } else if (key == "") {
    return true;
  }
};

const isValidEiaNumber = (e) => {
  var regex = new RegExp("^[0-9]{1,13}$");
  //var regex = new RegExp("/^[0-9]+$/");
  var regexValidNumber = new RegExp("^[0-9]{13}$"); // To check if 14 digits entered
  var key = e.target.value;

  if (key && !regex.test(key)) {
    //Modifications : to turn mobile box green after 10 digits
    if (
      e.target.value.length >= 14 &&
      //areAllDigitsSame === false &&
      regex.test(key)
    ) {
      //this.setState({ validNumber: true, value: e.target.value });
      return true;
    } else {
      e.target.value = key.replace(/\D/g, "").substr(0, 13);
      e.preventDefault();
      return false;
    }
  } else if (key && regexValidNumber.test(key)) {
    //Modifications : to turn mobile box green after 10 digits
    if (regex.test(key)) {
      //this.setState({ validNumber: true, value: e.target.value });
      return true;
      //this.verifyOtp(qid,e);
    } else {
      return false;
    }
  } else if (key && !regexValidNumber.test(key)) {
    
    return false;
  } else if (key == "") {
    return true;
  }
};

const isValidEmailID = (evt) => {
  const emailRegex = new RegExp(
    "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$"
  );
  if (emailRegex.test(evt.target.value)) {
    return true;
  } else {
    return false;
  }
};

const isValidPincode = (evt) => {
  var regex = new RegExp("^[0-9]{1,6}$");
  var key = evt.target.value;
  if (key && !regex.test(key)) {
    evt.target.value = key.replace(/\D/g, "").substr(0, 6);
    evt.preventDefault();
    return false;
  } else return true;
};

const validateQQForm = (coverType, laws, aid) => {
  let isValid = true;
  let adultCount = 0;
  let childCount = 0;
  let ageLaws = laws.AE[coverType];
  let countLaws = laws.NOIACT[coverType];
  let details = aid.details;
  let dobError = false;
  let countError = false;
  let actualAdultCount = aid.adultCount || 0;
  let actualChildCount = aid.childCount || 0;
  details.forEach((person) => {
    if (
      !moment(person.DOB, "DD/MM/YYYY", true).isValid() ||
      moment(person.DOB, "DD/MM/YYYY").year() < 1000
    ) {
      isValid = false;
    }
    if (
      moment().diff(
        moment(person.DOB, "DD/MM/YYYY"),
        ageLaws.minAdultAgeUnit
      ) >= ageLaws.minAdultAge
      // && moment().diff(moment(person.DOB,"DD/MM/YYYY"), ageLaws.maxAdultAgeUnit) <= ageLaws.maxAdultAge
    )
      ++adultCount;
    else if (
      moment().diff(
        moment(person.DOB, "DD/MM/YYYY"),
        ageLaws.minChildAgeUnit
      ) >= ageLaws.minChildAge &&
      moment().diff(
        moment(person.DOB, "DD/MM/YYYY"),
        ageLaws.maxChildAgeUnit
      ) <= ageLaws.maxChildAge
    )
      ++childCount;
    else {
      isValid = false;
      dobError = true;
    }
  });
  let peopleCount = childCount + adultCount;
  if (coverType != "familyfloater") {
    if (
      actualChildCount != 0 &&
      (childCount < actualChildCount || childCount < actualChildCount)
    ) {
      isValid = false;
      dobError = true;
    }
    if (
      actualAdultCount != 0 &&
      (adultCount < actualAdultCount || adultCount < actualAdultCount)
    ) {
      isValid = false;
      dobError = true;
    }
    if (peopleCount < countLaws.min || peopleCount > countLaws.max) {
      isValid = false;
      countError = true;
    }
    if (
      childCount < countLaws.minChild ||
      childCount > (countLaws.maxChild === 0 ? 7 : countLaws.maxChild)
    ) {
      isValid = false;
      countError = true;
    }
    if (adultCount < countLaws.minAdult || adultCount > countLaws.maxAdult) {
      isValid = false;
      countError = true;
    }
  }
  if (coverType === "familyfloater") {
    if (details[0].DOB) {
      let age = moment().diff(moment(details[0].DOB, "DD/MM/YYYY"), "years");
      if (
        age < ageLaws.minAdultAge
        // || age > 120
      ) {
        isValid = false;
        dobError = true;
      }
    }
    if (
      actualChildCount < countLaws.minChild ||
      actualChildCount > (countLaws.maxChild === 0 ? 7 : countLaws.maxChild)
    ) {
      isValid = false;
      countError = true;
    }
    if (
      actualAdultCount < countLaws.minAdult ||
      actualAdultCount > countLaws.maxAdult
    ) {
      isValid = false;
      countError = true;
    }
  }
  return {
    isValid,
    dobError,
    countError,
  };
};

const formatCurrency = (amount) => {
  var x = amount;
  x = x.toString();
  var afterPoint = "";
  if (x.indexOf(".") > 0) afterPoint = x.substring(x.indexOf("."), x.length);
  x = Math.floor(x);
  x = x.toString();
  var lastThree = x.substring(x.length - 3);
  var otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers != "") lastThree = "," + lastThree;
  var res =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  return res;
};

const getCurrentDate = () => {
  return moment(new Date()).format("DD/MM/YYYY");
};

const isValidDate = (dateString) => {
  return moment(dateString, "DD/MM/YYYY").isValid();
};

const numberValidator = (e) => {
  //console.log("numberValidator: " + e.key + " : " + e.keyCode + " : " + e.which)
  // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
  let checkIfNum;
  if (e.key !== undefined) {
    // Check if it's a "e", ".", "+" or "-"
    checkIfNum =
      e.key === "e" ||
      e.key === "." ||
      e.key === "+" ||
      e.key === "-" ||
      e.key === "ArrowUp" ||
      e.key === "ArrowDown";
    return checkIfNum && e.preventDefault();
  } else if (e.keyCode !== undefined) {
    // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
    checkIfNum =
      e.keyCode === 38 ||
      e.keyCode === 40 ||
      e.keyCode === 69 ||
      e.keyCode === 190 ||
      e.keyCode === 187 ||
      e.keyCode === 189;
    //checkIfNum = !checkIfNum
  }

  return !checkIfNum && e.preventDefault();
};

const rePaintMe = (benefits, plans) => {
  let qry = {};
  let query = [];
  _.forEach(benefits, (obj) => {
    if (obj.selected) {
      if (obj.type === "list") {
        if (obj.key === "DEDUCTIBLE")
          query.push(`DEDUCTIBLE_VALUE = ${obj.amount}`);
        else if (obj.amount.toString() === "0")
          query.push(`${obj.key}_VALUE = 0`);
        else {
          if (isNaN(obj.amount)) {
            query.push(`${obj.key}_VALUE = "${obj.amount}"`);
          } else {
            query.push(`${obj.key}_VALUE = ${obj.amount}`);
          }
        }
      } else {
        query.push(`${obj.key} > 0`);
      }
    } else {
      query.push(`${obj.key} = 0`);
    }
  });

  let premiumData = [];
  plans.forEach((plan) => {
    let pd = array.findPremiumLine(plan, query);
    premiumData.push(pd[0]);
  });
  return premiumData;
};

const generateBuyPlanRequest = (
  planObj,
  selectedProductId,
  qqID,
  planName,
  payoutOpt,
  riders,
  op,
  optionalCoversPremValues,
  isPoshPlan
) => {
  planName = planObj.SuggestionName;
  const optionalCoversArr =
    riders &&
    riders.length > 0 &&
    riders.map((item) => {
      let selected_benifitValue = optionalCoversPremValues.filter((o) => {
        return o.key == item.displayText;
      });
      let obj = {};
      obj["type"] = item.type;
      obj["benefitId"] = item.key;
      obj["benefitValue"] = selected_benifitValue[0].value;
      obj["displayText"] = item.displayText;
      obj["gst"] = null;
      obj["discount"] = null;
      obj["premiumAmount"] = null;
      obj["selectedPercentage"] = null;
      return obj;
    });
  let grouped_optinal_covers = _.groupBy(optionalCoversArr, "type");

  const ridersArr =
    grouped_optinal_covers &&
    grouped_optinal_covers.rider &&
    grouped_optinal_covers.rider.length > 0 &&
    grouped_optinal_covers.rider.map((item) => {
      delete item.type;
      return item;
    });

  let addonsArr = [];
  addonsArr =
    grouped_optinal_covers &&
    grouped_optinal_covers.addon &&
    grouped_optinal_covers.addon.length > 0
      ? grouped_optinal_covers.addon.map((item) => {
          delete item.type;
          return item;
        })
      : [];
  let op_arr = [];
  if (op && op.length > 0) {
    let selected_op = optionalCoversPremValues.filter((o) => {
      return o.key == op;
    });
    let benefitId = null;
    if (op == "ENHANCEPLUS") {
      benefitId = "OPPRENPL01";
    } else if (op == "ASSURE") {
      benefitId = "OPPRASR01";
    } else if (op == "ENHANCE") {
      benefitId = "OPPRENH01";
    } else if (op == "FREEDOM") {
      benefitId = "OPPRFRD01";
    }
    let obj = {};
    obj["benefitId"] = benefitId;
    obj["benefitValue"] = selected_op[0].value;
    obj["displayText"] = op;
    obj["gst"] = null;
    obj["discount"] = null;
    obj["premiumAmount"] = null;
    obj["selectedPercentage"] = null;
    op_arr.push(obj);
  }
  if (op_arr && op_arr.length > 0) {
    addonsArr = [...addonsArr, ...op_arr];
  }
  let reqObj = null;
  try {
    reqObj = {
      //productId: selectedProductId,
      productId:
      isPoshPlan ? planObj.SuggestionName == "Plus"
          ? "SPLS03POSLF"
          : planObj.SuggestionName == "Select"
          ? "LTGL01SBLF"
          : null : planObj.SuggestionName == "Plus"
          ? "SPLS03SBLF"
          : planObj.SuggestionName == "Select"
          ? "LTGL01SBLF"
          : null,
      productPlan: {
        plan: planName,
        planId: planObj.SuggestionCode,
        premium: planObj.FinalPremiumTable[0].MODAL_PREM_TAX,
        viewPlanId: planObj.viewPlanId,
      },
      payoutOption: payoutOpt,
      //quickQuoteId: qqID,
      riders: ridersArr && ridersArr.length > 0 ? ridersArr : null,
      additionalBenefits: addonsArr && addonsArr.length > 0 ? addonsArr : null,
    };

  } catch (error) {
    console.log("generateBuyPlanRequest: error " + JSON.stringify(error));
  }
  return reqObj;
};


const isValidAbhaNumber = (e) => {
  let value = e.target.value?.trim();
  if (value === "") {
    return true;
  }
  if (value.length < 14 && !value.includes("@")) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  } else {
    if (value.includes("@") && !value.includes(" ")) {
      if (
        value.split("@").length === 2 &&
        value.split("@")[1] === "abdm" &&
        value.split("@")[0] !== ""
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (value.length === 14) {
        return true;
      } else {
        return false;
      }
    }
  }
};

const isAbhaNumber = (evt) => {
  var k = evt ? evt.which : window.event.keyCode;
  if (k == 32) {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
  if (/^[a-zA-Z0-9@._ ]*$/.test(evt.key) || evt.key === "Backspace") {
    return true;
  } else {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
};

export const getURlParameter = (param) => {
  let sPageURl = window.location.search.substring(1);
  let sURLVriable = sPageURl.split("&");
  for (var i = 0; i < sURLVriable.length; i++) {
    let sParameterName = sURLVriable[i].split("=");
    if (sParameterName[0] == param) return sParameterName[1];
  }
};

export const isPanandProserNameSame = (propserFullName , selectedNamefromCard) =>{
  return  propserFullName?.toLocaleLowerCase().replace(/\s+/g, "") == selectedNamefromCard?.toLocaleLowerCase().replace(/\s+/g, "")
}

const doEncryption = (objData) => {
  let encodedObj = {
    encodedString: aesEcb.encrypt(process.env.REACT_APP_CRYPTO_KEY,JSON.stringify(objData)),
  };
  return encodedObj
}

const decryptResponse = (response) =>{
  let decryptedResponse = aesEcb.decrypt(
        process.env.REACT_APP_CRYPTO_KEY,
        response
      );
  return decryptedResponse
}

const refA_refB_ParentAgencyId =["1670521-01"]
const refA_refB_Chaneel_BCC = ["375"]


export {
  otp,
  HTTPRequest,
  generateBuyPlanRequest,
  submitData,
  moveBox,
  validateBox,
  applyOwlCarousel,
  applyResultOwlCarousel,
  applyDatepicker,
  applySelect2,
  applyTooltip,
  isNumberKey,
  isAlphabetKey,
  isAlphabetKeyWithSpace,
  isAlphabetNumericKey,
  isAlphabetKeyLastName,
  isValidKeyForAddress,
  isValidMobileNumber,
  isValidEmailID,
  isValidPincode,
  formatCurrency,
  validateQQForm,
  getCurrentDate,
  isValidDate,
  numberValidator,
  rePaintMe,
  isValidCkycNumber,
  isValidEiaNumber,
  isValidAbhaNumber,
  isAbhaNumber,
  doEncryption,
  decryptResponse,
  refA_refB_ParentAgencyId,
  refA_refB_Chaneel_BCC
};
